import { Action } from '@ngrx/store';

export const UPSERT = '[ORDER INFORMATION: ORDER REFERENCES] UPSERT';
export const CLEAR = '[ORDER INFORMATION: ORDER REFERENCES] CLEAR';

export class Upsert implements Action {
    readonly type = UPSERT;
    constructor(public payload: any) {
    }
}

export class Clear implements Action {
    readonly type = CLEAR;
    constructor() {
    }
}

export type OrderReferencesActions = Upsert
| Clear;


